/* Copyright 2017 The MathWorks, Inc. */

define([
    "dojo/_base/declare"
], function (declare) {
    return declare(null, {

        _removable: false,
        _removeMessage: "",

        _getRemovableAttr: function () {
            return this.get("_removable");
        },

        _setRemovableAttr: function (value) {
            if (typeof value !== "boolean") {
                throw new Error("'removable' property expected a boolean value.");
            }

            this._set("_removable", value);
            
            // IE does not set class properly during setter phase if using classList.toggle
            if (value) {
                this.domNode.classList.add("mwRemovableTrue");
            } else {
                this.domNode.classList.remove("mwRemovableTrue");
            }
        },

        _getRemoveMessageAttr: function () {
            return this.get("_removeMessage");
        },

        _setRemoveMessageAttr: function (value) {
            if (typeof value !== "string") {
                throw new Error("'_removeMessage' property expected a string value.");
            }

            this._set("_removeMessage", value);
        },

        _emitRemoveEvent: function () {
            this.emit("remove");
            this.remove();
        },

        remove: function () {
            // No-op to support aspect.after of old widgets
        }
    });
});